<script setup lang="ts">
  const props = withDefaults(
    defineProps<{
      height?: string;
      maxWidth?: string;
      black?: boolean;
    }>(),
    {
      height: '32',
      maxWidth: undefined,
      black: false,
    },
  );

  const logo = props.black ? 'logo-black' : 'logo';
</script>

<template>
  <Illustration
    :image="logo"
    :height="height"
    :max-width="maxWidth"
  />
</template>
